import {shouldHideCoaching} from '../../util';

/**
 * Work out the single most useful CTA for this user.
 *
 * Analytics used to live here for org admins, but it now has a permanent home
 * in the sidebar; duplicating it would spend the one high-value slot on a
 * link that is already one click away. Upgrade is the conversion path.
 */
const getActionLink = ({currentUser, hasSubscription}, upgradeLink) => {
  if (hasSubscription && !shouldHideCoaching(currentUser)) {
    return {link: '/coaching?src=nav', text: 'Get coaching'};
  }
  if (hasSubscription) return null;
  return {link: upgradeLink, text: 'Upgrade', isUpgrade: true};
};

export default getActionLink;
